<template>
  <offer-question-form />
</template>

<script>
import OfferQuestionForm from "./OfferQuestionForm.vue";

export default {
  components: { OfferQuestionForm },
};
</script>
